module.exports = __webpack_public_path__ + "static/media/CARNAGE2.bd721ebd.svg";